import { all, AllEffect, call, fork, put, takeLatest } from '@redux-saga/core/effects';
import { Effect } from 'redux-saga/effects';
import axios from 'axios';

import {
  GET_CLUB_OPTIONS_REQUEST,
  GET_CLUB_OPTIONS_SUCCESS,
  GET_CLUB_OPTIONS_FAILURE,
  COMMON_FAILURE,
} from '../../actions';
import reservationService from '../../services/reservationService';

/**
 * 店舗検索オプション取得アクションの型定義
 */
export type GetClubOptionsActionType = {
  type: typeof GET_CLUB_OPTIONS_REQUEST;
  history?: any;
};

/**
 * 店舗検索オプション取得のSaga処理
 */
function* getClubOptions(action: GetClubOptionsActionType): Generator<unknown> {
  try {
    console.log('[reservationSaga] getClubOptions - 開始');

    // TODO: 後端準備完了後、実際のAPIを呼び出す
    const res: any = yield call(reservationService().getClubOptions);

    console.log('[reservationSaga] getClubOptions - レスポンス:', res);

    // 成功時の処理
    yield put({
      type: GET_CLUB_OPTIONS_SUCCESS,
      res,
    });

    console.log('[reservationSaga] getClubOptions - 成功');
  } catch (error) {
    console.error('[reservationSaga] getClubOptions - エラー:', error);

    if (axios.isAxiosError(error)) {
      // Axiosエラーの場合
      yield put({
        type: GET_CLUB_OPTIONS_FAILURE,
        error: error.response,
      });

      // 共通エラー処理
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    } else {
      // その他のエラーの場合
      yield put({
        type: GET_CLUB_OPTIONS_FAILURE,
        error: { data: { message: 'エラーが発生しました' } },
      });
    }

    // エラー時にシステムエラーページへ遷移(必要に応じて)
    // if (action.history) {
    //   action.history.push('/systemError');
    // }
  }
}

/**
 * 店舗検索オプション取得アクションの監視
 */
function* watchGetClubOptions() {
  yield takeLatest(GET_CLUB_OPTIONS_REQUEST, getClubOptions);
}

/**
 * Reservation関連のSagaをまとめる
 */
export default function* reservationSaga(): Generator<AllEffect<Effect>> {
  yield all([fork(watchGetClubOptions)]);
}
